import { StateCreator } from "zustand";
import { AuthStoreType } from "../useAuthStore";
import { DashboardUser } from "@/core/models/Auth.model";
import LoginService from "@/core/services/AuthService";

export interface AuthSlice {
  signFormsType: string | null;
  setSignFormsType: (type: string) => void;
  OTPData: any | null;
  setOTPData: (data: any) => void;
  currentLang: any | null;
  setCurrentLang: (data: any) => void;
  direction: any | null;
  setDirection: (data: any) => void;
  dashboardUsers: DashboardUser[] | null;
  isLoadingDashboardUsers: boolean;
  fetchDashboardUsers: (type: string) => Promise<void>;
  resetDashboardUsers: () => void;
}

const createAuthSlice: StateCreator<AuthStoreType, [], [], AuthSlice> = (
  set
) => ({
  signFormsType: null,
  OTPData: null,
  currentLang: null,
  direction: null,
  dashboardUsers: null,
  isLoadingDashboardUsers: false,
  setSignFormsType: (type: string) => {
    set(() => ({
      signFormsType: type,
    }));
  },
  setOTPData: (data: any) => {
    set(() => ({
      OTPData: data,
    }));
  },
  setCurrentLang: (data: any) => {
    set(() => ({
      currentLang: data,
    }));
  },
  setDirection: (data: any) => {
    set(() => ({
      direction: data,
    }));
  },

  fetchDashboardUsers: async (type: string) => {
    set({ isLoadingDashboardUsers: true });
    try {
      const response = await LoginService.getAllDashboardUsers(type);
      set({ dashboardUsers: response.data ?? null });
    } catch (error) {
      console.error("Error fetching dashboard users:", error);
    } finally {
      set({ isLoadingDashboardUsers: false });
    }
  },
  resetDashboardUsers: () =>
    set({ dashboardUsers: null, isLoadingDashboardUsers: false }),
});

export default createAuthSlice;
